import { render } from "./VerPromociones.vue?vue&type=template&id=010d01c8"
import script from "./VerPromociones.vue?vue&type=script&lang=js"
export * from "./VerPromociones.vue?vue&type=script&lang=js"

import "./VerPromociones.vue?vue&type=style&index=0&id=010d01c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__